<template>
  <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="videoOptions" />
</template>

<script>
import Vue from 'vue'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import { fileTestLocal } from '@File~/api/file'
export default {
  props: {
    sources: {
      type: Object,
      default: () => { },
      required: true
    }
  },
  data() {
    return {
      value: 1,
      videoOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        controls: true,
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{ type: '', src: '' }], //this.sources,
        poster: '', //this.poster, //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '仅支持MP4格式在线播放，其他格式请下载后自行播放', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,//当前时间和持续时间的分隔符
          durationDisplay: true,//显示持续时间
          remainingTimeDisplay: true,//是否显示剩余时间功能
          fullscreenToggle: true  //全屏按钮
        }
      }
    }
  },

  watch: {
  },
  mounted() {
    this.fileTestLocals()
  },
  methods: {
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    fileTestLocals() {
      var b = true;
      fileTestLocal().then(response => {
        if (response.code == 1) {
          b = false;
          this.value = 1;
          this.getDownloadUrl() // 获取下载地址
        }
      })
      setTimeout(() => {
        if (b) {
          this.value = 2;
        }
        this.getDownloadUrl() // 获取下载地址
      }, 150);
    },
    // 获取文件下载地址
    getDownloadUrl() {
      // videoPage/videoPlay?fileId=863232
      if (this.value == 1) {
        var url = process.env.VUE_APP_TITLE === 'production' ? "https://local-gateway.yingxiong.com/file/api/file/loadFileBinary" : "https://local-gateway.yingxiong.com/testFile/api/file/loadFileBinary"
      } else if (this.value == 2) {
        var url = process.env.VUE_APP_TITLE === 'production' ? "https://nps-bdc.yingxiong.com/tfile/api/file/loadFileBinary" : "https://nps-bdc.yingxiong.com/testGatewayFile/api/file/loadFileBinary"
      }

      this.videoOptions.sources[0].src = url + "?fileId=" + this.getUrlKey("fileId")
      this.videoOptions.sources[0].type = 'video/mp4'

    }
  },
}
</script>

<style lang="scss" scoped>
.video-player {
  width: auto;
  height: auto;
  position: relative;
}
::v-deep .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translateY(-50%), translateX(-50%);
}
</style>